import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "../../../../../shared/loader/Loader";
import './SubscriptionDetails.css'
import { DisplayDate } from "../../../../../../utils/DisplayDate";
import { Card, CardHeader, ListGroup, ListGroupItem, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { SUCCESS } from "../../../../../../constants/AppConstants";
import { currentUserRolesArr } from "../../../../../../constants/AppMethod";
import { canAccess_CancelSubscription } from "../../../../../../constants/UserRoles";
import EcoProButton from "../../../../../shared/button/button";
import EcoProOverlayModal from "../../../../../shared/modal/OverlayModal/EcoProOverlayModal";
import Feedback from "../../../../../../pages/Account/CancelPlan/Feedback/Feedback";
import { useSelector } from "react-redux";

const BrotherPlusSubscriptionDetails = ({ customerInfo, getUserSubscriptionDetails }) => {
    const { t } = useTranslation("CSAgenttranslation");
    const TABS = {
        'BROTHER_PLUS_SUBSCRIPTION_INFO': 'BROTHER_PLUS_SUBSCRIPTION_INFO'
    }
    const currentUserRoles = currentUserRolesArr();
    const NOT_AVAILABLE = "N/A";

    // get user details
    const { displayName, emailAddress, countryCode, userId, businessPartnerId, personalOrBusiness } = customerInfo || {};

    const { subscriptionDetails: detailsWrapper, error, loading } = getUserSubscriptionDetails || {};
    const [activeTab, setActiveTab] = useState((detailsWrapper?.subscriptionDetails?.length > 0)
        ? detailsWrapper?.subscriptionDetails[0]?.deviceId
        : null);

    const [selectedSubscriptionDetails, setselectedSubscriptionDetails] = useState(
        (detailsWrapper?.subscriptionDetails?.length > 0)
            ? detailsWrapper?.subscriptionDetails[0]
            : null);

    const [modalState, setModalState] = useState(false);
    const [modalProps, setModalProps] = useState({
        modal_title: "",
        modal_sub_title: "",
        modal_content: "",
        cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
        confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
        toggleModal: "",
        customClassName: "",
        confirm_btn_onClick: "",
        type: "normal"
    })

    const brotherPlusCancelServiceResponse = useSelector((state => state.BROTHERPLUS.cancelService))
    const [callCancelOrder, setcallCancelOrder] = useState(true);

    const cancellationFeedbackProperties = {
        'deviceId': null,
        'customerCountryCode': countryCode,
        'customerUserId': userId,
        'confirmStatus': true,
        'customerBP_ID': businessPartnerId,
        'displayName': displayName,
        'personalOrBusiness': personalOrBusiness,
        'serialNumber': null,
        'model': null
    }

    useEffect(() => {
        if (detailsWrapper && detailsWrapper?.actionStatus?.toUpperCase() === SUCCESS) {
            if ((detailsWrapper?.subscriptionDetails?.length > 0)) {
                setActiveTab(detailsWrapper?.subscriptionDetails[0]?.deviceId);
                setselectedSubscriptionDetails(detailsWrapper?.subscriptionDetails[0]);
            } else {
                setActiveTab(TABS.BROTHER_PLUS_SUBSCRIPTION_INFO);
            }
        }
    }, [TABS.BROTHER_PLUS_SUBSCRIPTION_INFO, detailsWrapper]);

    useEffect(() => {
        if (brotherPlusCancelServiceResponse.loading) {
            setModalState(false);
        }
    }, [brotherPlusCancelServiceResponse.loading]);

    if (loading) {
        return <div><Loader /></div>;
    }

    if (error) {
        return <div className="email-log-error">{t("ERROR_MESSAGES.NO_SUBSCRIPTION_INFO_AVAILABLE")}</div>;
    }

    const toggleModal = (event) => {
        setModalState(false);
    }

    const constructUserInfoContent = (name, emailId, serialNumber) => {
        return <>
            <p>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.MODAL_CONTENT")}</p>
            <ul>
                <li><span>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.NAME")}:&nbsp;&nbsp;&nbsp;</span> <span>{name}</span></li>
                <li><span>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.EMAIL")}:&nbsp;&nbsp;&nbsp;</span> <span>{emailId}</span></li>
                <li><span>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.SERIAL_NUMBER")}:&nbsp;&nbsp;&nbsp;</span> <span>{serialNumber}</span></li>
            </ul>
        </>
    }

    const confirmedCancellation = () => {
        cancellationFeedbackProperties.deviceId = selectedSubscriptionDetails?.deviceId || null;
        cancellationFeedbackProperties.serialNumber = selectedSubscriptionDetails?.serialNumber || null;
        cancellationFeedbackProperties.model = selectedSubscriptionDetails?.model || null;
        setModalState(true);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_FEEDBACK_MODAL_TITLE"),
            modal_content: <Feedback {...{ ...cancellationFeedbackProperties, ...{ 'csAgentBrotherPlusCancellation': true } }} />,
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-feedback",
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL")
        });
    }

    const handlePlanCancellationModal = (selectedSubscription) => {
        setModalState(true);
        setselectedSubscriptionDetails(selectedSubscription);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.MODAL_TITLE"),
            modal_content: constructUserInfoContent(displayName, emailAddress, selectedSubscription?.serialNumber),
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-confirmation",
            confirm_btn_onClick: confirmedCancellation,
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
            confirm_btn_text: t("MODAL_BUTTON_TXT.CONTINUE"),
        });
    }

    if ((brotherPlusCancelServiceResponse.success || brotherPlusCancelServiceResponse.error) && callCancelOrder) {
        setModalState(true);
        setModalProps({
            modal_title: (brotherPlusCancelServiceResponse.success)
                ? t('CONFIRM_CANCELLATION.CANCELLATION_COMPLETION_TITLE.SUCCESS')
                : t('CONFIRM_CANCELLATION.CANCELLATION_COMPLETION_TITLE.ERROR'),
            modal_content: <>
                <p>
                    {
                        (brotherPlusCancelServiceResponse.success)
                            ? t("CONFIRM_CANCELLATION.CANCELLATION.SUCCESS")
                            : t("CONFIRM_CANCELLATION.CANCELLATION.ERROR")
                    }
                </p>
                <p>{t('CONFIRM_CANCELLATION.DATA_REFRESHING_CONTENT')}</p>
            </>,
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-final-status"
        });
        setcallCancelOrder(false);
        setTimeout(() => {
            window.location.reload();
        }, 6000);
    }

    return (

        <div className="overview-container subscription-details-wrapper mt-40">
            {brotherPlusCancelServiceResponse.loading && <Loader setOverlay={true}></Loader>}
            <div id="brother-plus-subscription-billing-details">
                <div className="tab-btn-wrapper">
                    <div>
                        <Nav tabs>
                            {(detailsWrapper?.subscriptionDetails?.length > 0) ?
                                detailsWrapper?.subscriptionDetails?.map((subscription) => (
                                    <NavItem>
                                        <NavLink active={activeTab === subscription.deviceId} onClick={() => {
                                            setActiveTab(subscription.deviceId);
                                            setselectedSubscriptionDetails(subscription);
                                        }}>
                                            {subscription.serialNumber}
                                        </NavLink>
                                    </NavItem>
                                )) :
                                <NavItem>
                                    <NavLink active={activeTab === TABS.BROTHER_PLUS_SUBSCRIPTION_INFO} onClick={() => {
                                        setActiveTab(TABS.BROTHER_PLUS_SUBSCRIPTION_INFO);
                                        setselectedSubscriptionDetails(null);
                                    }}>
                                        {t('CUSTOMER_DASHBOARD.TAB_ITEMS.BROTHERPLUS_SUBSCRIPTION_DETAILS')}
                                    </NavLink>
                                </NavItem>
                            }
                        </Nav>
                    </div>
                </div>
                <div className="subscription-info-content-wrapper">
                    <TabContent activeTab={activeTab}>
                        {
                            (detailsWrapper?.subscriptionDetails?.length > 0) ?
                                detailsWrapper?.subscriptionDetails?.map((subscription, index) => (
                                    <TabPane tabId={subscription.deviceId}>
                                        <Card key={index} className="mt-30">
                                            <CardHeader>
                                                {t('CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_SUBSCRIPTION_DETAILS.SERIAL_NUMBER')} :
                                                {subscription?.serialNumber || NOT_AVAILABLE}
                                            </CardHeader>
                                            <ListGroup flush>
                                                <div className="device-details-info mt-15">
                                                    <SubscriptionLineItem
                                                        label={t('CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_SUBSCRIPTION_DETAILS.ENROLLMENT_STATUS')}
                                                        value={t(`CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_SUBSCRIPTION_DETAILS.STATUS.${subscription?.enrollmentStatus}`)}
                                                    />
                                                    {(subscription?.enrollmentStatus === "EnrollmentSuccessful") ?
                                                        <SubscriptionLineItem
                                                            label={t("CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_SUBSCRIPTION_DETAILS.ENROLLMENT_DATE")}
                                                            value={DisplayDate(subscription?.enrollmentDate, { day: '2-digit', month: 'long', year: 'numeric' }) || "N/A"}
                                                        /> : null
                                                    }
                                                    {(subscription?.enrollmentStatus === "EnrollmentCancelled") ?
                                                        <SubscriptionLineItem
                                                            label={t("CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_SUBSCRIPTION_DETAILS.CANCELLED_DATE")}
                                                            value={DisplayDate(subscription?.cancelledDate, { day: '2-digit', month: 'long', year: 'numeric' }) || "N/A"}
                                                        /> : null
                                                    }
                                                </div>
                                            </ListGroup>
                                        </Card>
                                        {(canAccess_CancelSubscription(subscription?.enrollmentStatus, currentUserRoles)) ?
                                            <Card key={`cancel-card-${index}`} className="mt-30">
                                                <CardHeader>
                                                    {t('CUSTOMER_DASHBOARD.SUBSCRIPTION_CANCELLATION.header')}
                                                </CardHeader>
                                                <ListGroup flush>
                                                    <ListGroupItem>
                                                        <div className="cancellation-btn">
                                                            <EcoProButton cname="default" btnID="csagent-subscription-cancellation-btn" onBtnClick={() => handlePlanCancellationModal(subscription)}>{t('MODAL_BUTTON_TXT.CANCEL')}</EcoProButton>
                                                        </div>
                                                    </ListGroupItem>
                                                </ListGroup>
                                            </Card> : null
                                        }
                                    </TabPane>
                                )) :
                                <TabPane tabId={TABS.BROTHER_PLUS_SUBSCRIPTION_INFO}>
                                    <div className="email-log-error">{t("ERROR_MESSAGES.NO_SUBSCRIPTION_INFO_AVAILABLE")}</div>
                                </TabPane>
                        }
                    </TabContent>
                </div>
            </div>
            <EcoProOverlayModal
                {...modalProps}
                modal_state={modalState}
            ></EcoProOverlayModal>
        </div>
    );
};

const SubscriptionLineItem = ({ label, value, classNameValues = "" }) => {
    return (
        <ListGroupItem>
            <p>{label}:
                <span className={`${classNameValues}`}>{value}</span>
            </p>
        </ListGroupItem>
    )
}

export default BrotherPlusSubscriptionDetails;
